import { render, staticRenderFns } from "./evaultApp.vue?vue&type=template&id=bcb9d41c&scoped=true"
import script from "./evaultApp.vue?vue&type=script&lang=js"
export * from "./evaultApp.vue?vue&type=script&lang=js"
import style0 from "./evaultApp.vue?vue&type=style&index=0&id=bcb9d41c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb9d41c",
  null
  
)

export default component.exports